import { useContext, useEffect, useRef } from 'react';
import {
  AccessibilityContext,
  NotificationContext,
} from '@monash/portal-frontend-common';
import { UpdatesContext } from '../../components/providers/updates-provider/UpdatesProvider';
import { generateAnnouncementText } from './generate-announcement-text';

export const useAnnouncements = () => {
  const lastNotificationsCount = useRef(0);
  const lastUpdatesCount = useRef(0);

  const { showNotificationsList } = useContext(NotificationContext);
  const { resetAppLiveMsgs, setAppLivePoliteMsg } =
    useContext(AccessibilityContext);

  const { newCount: newUpdatesCount, isLoading } = useContext(UpdatesContext);
  const newNotificationsCount = Object.keys(showNotificationsList).length;

  useEffect(() => {
    if (!isLoading) {
      const text = generateAnnouncementText({
        newNotificationsCount,
        newUpdatesCount,
      });

      const notificationsHasIncreased =
        lastNotificationsCount.current < newNotificationsCount;
      const updatesHasIncreased = lastUpdatesCount.current < newUpdatesCount;
      const hasIncreased = notificationsHasIncreased || updatesHasIncreased;

      if (hasIncreased) {
        if (text) {
          resetAppLiveMsgs();

          setTimeout(() => {
            setAppLivePoliteMsg(text);
          }, 300);
        } else {
          setAppLivePoliteMsg('');
        }
      }

      lastNotificationsCount.current = newNotificationsCount;
      lastUpdatesCount.current = newUpdatesCount;
    }
  }, [newNotificationsCount, newUpdatesCount, isLoading]);
};
